module.exports = __webpack_public_path__ + "img/login-bg03.9c6eebde.png";